import { FeatureType } from '@trustero/trustero-api-web/lib/trust/trust_pb'
import { SortableHeaderColumn } from 'src/components/Reusable/Grid/GridColumnFrontendSort/SortableHeader'
import { GridColumnSortVisitorAnalytics } from 'src/components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'
import { DashboardDataPoint } from 'src/Utils/dashboards/dashboards.types'

export type AnalyticsGridConfig = {
  gridTemplateColumns: string
  headers: SortableHeaderColumn<GridColumnSortVisitorAnalytics>[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataFormatters: Record<string, (item: any) => string>
}

export enum AnalyticsDashboardParam {
  ACCESS_REQUESTS = 'access_requests',
  GRANTED_REQUESTS = 'granted_requests',
  DOCUMENT_DOWNLOADS = 'document_downloads',
  FAQ_CLICKS = 'faq_clicks',
  SEARCHES = 'searches',
  TI_CHATS = 'ti_chats',
  TI_QUESTIONS = 'ti_questions',
  UPDATE_NOTIFICATION_SUBSCRIPTIONS = 'update_subscriptions',
  UPDATE_NOTIFICATION_UNSUBSCRIPTIONS = 'update_unsubscriptions',
}

export enum AnalyticsDashboardQueryParam {
  ACTIVE_DASHBOARD = 'active_dashboard',
}

export enum AnalyticsDashboardName {
  ACCESS_REQUESTS = 'Access requests',
  GRANTED_REQUESTS = 'Granted requests',
  DOCUMENT_DOWNLOADS = 'Documents downloaded',
  FAQ_CLICKS = 'FAQs clicked',
  SEARCHES = 'Searches',
  TI_CHATS = 'TI chats',
  TI_QUESTIONS = 'TI questions',
  UPDATE_NOTIFICATION_SUBSCRIPTIONS = 'Subscribed to updates',
  UPDATE_NOTIFICATION_UNSUBSCRIPTIONS = 'Unsubscribed from updates',
}

export enum AnalyticsDashboardRequestName {
  TRUST_PORTAL_ACCESS_REQUESTS = 'pending_requests/trm_trust_portal_access_grant',
  TRUST_PORTAL_GRANTED_REQUESTS = 'granted_requests/trm_trust_portal_access_grant',
  TRUST_PORTAL_DOCUMENT_DOWNLOADS = 'downloads/trm_trust_portal_document_download',
  TRUST_PORTAL_FAQ_CLICKS = 'faq_clicks/trm_trust_portal_faq_click',
  TRUST_PORTAL_SEARCHES = 'searches/trm_trust_portal_search',
  TRUST_PORTAL_TI_CHATS = 'ti_chats/trm_trust_portal_ti_chat',
  TRUST_PORTAL_TI_QUESTIONS = 'ti_questions/trm_trust_portal_ti_question',
  TRUST_PORTAL_UPDATE_SUBSCRIPTIONS = 'tp_subscribe/trm_trust_portal_update_subscription',
  TRUST_PORTAL_UPDATE_UNSUBSCRIPTIONS = 'tp_unsubscribe/trm_trust_portal_update_subscription',
}

export enum AnalyticsSectionType {
  OVERVIEW = 'Overview',
  DETAIL = 'Detail',
}

export type VisitorAnalyticsDataPoint = DashboardDataPoint & {
  name: string
  email: string
  org_name: string
  features: FeatureType[]
  doc_name: string
  privacy_level: string
  url: string
  faq_title: string
  search_query: string
  chat_id: string
  question: string
  date: string
  category: string
}
